import { useState, useMemo } from 'react'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import ListSubheader from '@mui/material/ListSubheader'
import Stack from '@mui/material/Stack'
import TextButton from 'components/TextButton'
import { groupBy, sortBy, map, uniqBy } from 'lodash'

const TextButtonMenu = ({ label, options, renderInput, onSelect }) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const groupedOptions = useMemo(() => {
    const groups = groupBy(map(options, (value, key) => ({ ...value, key })), 'group')
    Object.keys(groups).forEach(group => {
      groups[group] = sortBy(uniqBy(groups[group], 'name'), 'name')
    })
    return groups
  }, [options])

  return (
    <div>
      <TextButton 
        color="tertiary" 
        onClick={handleClick}
      >
        {label}
      </TextButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        sx={{
          maxHeight: 600,
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {map(groupedOptions, (group, groupName) => (
          <Stack 
            key={groupName} 
            // spacing={1}
          >
            <ListSubheader
              component="div"
              sx={theme => ({
                px: 1.5,
                // px: 2,
                backgroundColor: 'background.paper.main',
                borderBottom: `1px solid ${theme.palette.border.neutralCool_300}`,
              })}
            >
              <Stack
                sx={theme => theme.internalMixins.columns({ gap: 1 })}
                color="text.main"
              >
                {/* <Icon
                  icon={ICONS[params.group]}
                /> */}
                {groupName}
              </Stack>
            </ListSubheader>
            {map(group, (value, key) => renderInput?.(
              <MenuItem
                key={`textButtonMenu_${key}`}
                onClick={() => {
                  onSelect?.(value)
                  handleClose() 
                }}
              >
                {value?.name || value}
              </MenuItem>,
              value
            ))}
          </Stack>
        ))}
      </Menu>
    </div>
  )
}

export default TextButtonMenu